import { scheduleMeeting } from './getSmartTimeForItem.locstring.json';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import loc from 'owa-localize';
import { FeatureNames } from 'owa-mail-smart-pill-features';
import { SmartPillData, SmartPillLogData } from 'owa-smart-pill';
import { IContextualMenuProps } from 'office-ui-fabric-react/lib/components/ContextualMenu';

/**
 * Create smart time pill with custom user action
 */
export default function createSmartTimePillData(
    index: number,
    smartTime: string,
    userClick: () => void,
    logData: SmartPillLogData,
    confidenceScore: number,
    iconProps?: IIconProps,
    menuProps?: IContextualMenuProps
): SmartPillData {
    return {
        ariaLabel: loc(scheduleMeeting),
        featureName: FeatureNames.SmartTime,
        onClick: userClick,
        index: index,
        logData: logData,
        text: smartTime,
        toolTip: smartTime,
        icon: iconProps,
        confidenceScore: confidenceScore,
        menuProps: menuProps,
    };
}
